import AppState from '../../AppState';
/**
 * One Platform send to sales funnel.
 *
 * @param drupalJsObjects
 *   Drupal JS objects.
 * @param quoteId
 *   The quote ID returned from the Quote API.
 * @param token
 *   The GUID generated.
 */
const onePlatformSendToSalesFunnel = (quoteId, token) => {
    const drupalJsObjects = AppState.get('drupalJsObjects');
    const { Window, settings } = drupalJsObjects;
    const { purchaseFunnelRoot } = settings;
    Window.location.href = `${purchaseFunnelRoot}internet/addons?quoteId=${quoteId}&token=${token}`;
};
export default onePlatformSendToSalesFunnel;
